import SpriteSymbol from "svg-baker-runtime/browser-symbol";
import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
var symbol = new SpriteSymbol({
  "id": "user_unlock",
  "use": "user_unlock-usage",
  "viewBox": "0 0 195 195",
  "content": "<symbol viewBox=\"0 0 195 195\" id=\"user_unlock\"><path d=\"M90.39 114.28v37.61c0 3.19.96 6.16 2.62 8.63H33.52c-6.64 0-12.02-5.38-12.02-12.01 0-13.75 5.57-26.19 14.58-35.2s21.46-14.58 35.2-14.58h8.31c6.03 0 11.8 1.07 17.15 3.03-3.84 2.82-6.35 7.38-6.35 12.52z\" /><circle cx=\"75.44\" cy=\"61.16\" r=\"26.97\" /><path d=\"M164.58 105.36H122.31V90.3c0-6.97 5.35-12.98 12.31-13.32 7.44-.37 13.6 5.58 13.6 12.94v5a2.57 2.57 0 0 0 2.57 2.57h7.53a2.57 2.57 0 0 0 2.57-2.57v-5c0-7.08-2.87-13.49-7.51-18.13a25.577 25.577 0 0 0-18.57-7.51c-14.08.24-25.19 12.12-25.19 26.2v14.87h-3.67c-4.93 0-8.92 3.99-8.92 8.92v37.61c0 4.93 3.99 8.92 8.92 8.92h58.62c4.93 0 8.92-3.99 8.92-8.92v-37.61c.01-4.92-3.98-8.91-8.91-8.91z\" /></symbol>"
});
var result = sprite.add(symbol);
export default "#" + symbol.id


//////////////////
// WEBPACK FOOTER
// ./src/assets/svg/user_unlock.svg
// module id = 643s
// module chunks = 1